import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getEntityTypeList } from "../../redux/actions/getEntityTypeListAction";
import { getEntityTypeListTable } from "../../redux/actions/getEntittyTypeListTableAction";
import { addOrUpdateEntityTypeList } from "../../redux/actions/addOrUpdateEntityTypeListAction";
import { getLoadLimitList } from "../../redux/actions/getLoadLimitListAction";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Util from "../../validation";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import SearchIcon from "@mui/icons-material/Search";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminEntityTypeManagement = () => {
	const [entityType, setEntityType] = useState("");
	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);
	const [getEntityTypeStatus, setGetEntityTypeStatus] = useState(false);
	const [getEntityTypeResArray, setGetEntityTypeResArray] = useState([]);

	const [getEntityTypeTableStatus, setGetEntityTypeTableStatus] =
		useState(false);
	const [getEntityTypeTableResArray, setGetEntityTypeTableResArray] = useState(
		[]
	);

	const [updateEntityType, setUpdateEntityType] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [editEntityType, setEditEntityType] = useState("");
	const [isIndividual, setIsIndividual] = useState("");
	const [operationId, setOperationId] = useState("");

	const [updateEntityTypeResArray, setUpdateEntityTypeResArray] = useState("");

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getEntityTypeListRes = useSelector(
		({ getEntityTypeList }) => getEntityTypeList
	);

	const getEntityTypeListTableRes = useSelector(
		({ getEntityTypeListTable }) => getEntityTypeListTable
	);

	const updateEntityTypeRes = useSelector(
		({ addOrUpdateEntityTypeList }) => addOrUpdateEntityTypeList
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setEditEntityType("");
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "EntityType") {
			setEntityType(value == "Select Level" ? "" : value);
		}

		if (name === "EditEntityType") {
			Util.alphaNumeric(value)
				? setEditEntityType(value)
				: setEditEntityType(editEntityType);
		}
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getEntityTypeListTableReq();
			getEntityTypeListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getEntityListStatusFunc = () => {
		if (getEntityTypeStatus) {
			if (getEntityTypeListRes.data.status == "success") {
				setGetEntityTypeResArray([].concat(getEntityTypeListRes.data.roleList));
				setIsLoading(false);
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getEntityTypeListRes.data.description ||
					getEntityTypeListRes.description
				);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getEntityTypeListRes.data.status == "NOT FOUND") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"NOT FOUND",
					getEntityTypeListRes.data.description ||
					getEntityTypeListRes.description
				);
			}
			if (getEntityTypeListRes.data.status == "INVALID REQUEST") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"INVALID REQUEST",
					getEntityTypeListRes.data.description ||
					getEntityTypeListRes.description
				);
			}
		}
	};

	useEffect(() => {
		getEntityListStatusFunc();
	}, [getEntityTypeListRes.data.status]);

	const getEntityTypeListReq = () => {
		setGetEntityTypeStatus(true);
		setIsLoading(true);
		dispatch(
			getEntityTypeList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						entityType: entityType
					}
				},
				authToken
			)
		);
	};

	const getEntityTypeListTableReq = () => {
		setGetEntityTypeTableStatus(true);
		dispatch(
			getEntityTypeListTable(
				{
					ownerMasterRequestVO: {
						// adminId: 2
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};

	const getEntityListTableStatusFunc = () => {
		if (getEntityTypeTableStatus) {
			if (getEntityTypeListTableRes.data.status == "success") {
				setGetEntityTypeTableResArray(
					[].concat(getEntityTypeListTableRes.data.roleList)
				);
			}
			if (getEntityTypeListTableRes.data.status == "failed") {
				setGetEntityTypeTableResArray(getEntityTypeListTableRes.data);
				if (
					getEntityTypeListTableRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListTableRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getEntityListTableStatusFunc();
	}, [getEntityTypeListTableRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setEditEntityType("");
	};

	const handleCheckboxChange = (e) => {
		const { checked } = e.target;
		if (checked) {
			setIsIndividual(true);
		} else {
			setIsIndividual(false);
		}
	};

	const updateEntityTypeList = (row, fs) => {
		console.log(fs, "{{{{{{{{{{{{{{{{{{{");
		setEditEntityType(row.entityType);
		row.isIndividual == "Y" ? setIsIndividual(true) : setIsIndividual(false);
		setOperationId(row.operationId);
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
	};

	// ADD AND UPDATE

	const updateEntityTypeFunc = () => {
		setEditOpen(false);
		setAddOpen(false);
		setUpdateEntityType(true);
		const addOrUpdateEntityTypeReq = {
			// adminId: 2,
			adminId: val.adminIDS,
			
			operationId: operationId,
			entityType: editEntityType,
			individualAddRequired: isIndividual ? "Y" : "N"
		};
		dispatch(addOrUpdateEntityTypeList(addOrUpdateEntityTypeReq, authToken));
		setOperationId("");
		setIsIndividual("");
		setEditEntityType("");
	};

	const updateEntityTypeStatus = () => {
		if (updateEntityType) {
			if (updateEntityTypeRes.data.status == "success") {
				setUpdateEntityTypeResArray(updateEntityTypeRes.data);
				setNotificationOpen(true);
				getEntityTypeListReq();
				getEntityTypeListTableReq();
				setEditEntityType("");
			}
			if (updateEntityTypeRes.data.status == "failed") {
				setUpdateEntityTypeResArray(updateEntityTypeRes.data);
				setNotificationOpen(true);
				if (
					updateEntityTypeRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateEntityTypeRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateEntityTypeStatus();
	}, [updateEntityTypeRes.data.status]);

	const addEntity = () => {
		setAddOpen(true);
		setEditEntityType("");
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						<Grid item xs={12} md={3} sm={12} lg={3} style={{ display: 'flex', justifyContent: 'center' }}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addEntity()}
							>
								Add New Entity Type
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={() => addEntity()}
							// onClick={getgateWayTransactionListReq}
							>
								Add New Entity Type
							</CustomButton>
						</Grid>
						<Grid item xs={12} md={3} sm={12} lg={3} style={{ display: 'flex', justifyContent: 'center' }}>
							<NavLink to="/index/mapping-entity-type">
								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									Mapping Entity Type
								</Button> */}
								<CustomButton
									style={{
										padding: "8px",
										marginLeft: "15px"
									}}

								// onClick={getgateWayTransactionListReq}
								>
									Mapping Entity Type
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"
								type="text"
								label="Entity Type"
								fullWidth={true}
								name="EntityType"
								value={entityType || "Select Level"}
								defaultValue={"Select Level" || entityType}
								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Entity Type
								</MenuItem>
								{getEntityTypeListTableRes.data.roleList &&
									getEntityTypeTableResArray.map((x) => (
										<MenuItem value={x.entityType}>{x.entityType}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getEntityTypeListReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getEntityTypeListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getEntityTypeResArray.length == undefined ||
					getEntityTypeResArray.status == "NOT FOUND" ||
					getEntityTypeResArray.status == "INVALID REQUEST" ||
					!getEntityTypeStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Entity Type ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Entity Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
											{/* <TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Edit
											</TableCell> */}
										</TableRow>
									</TableHead>

									<TableBody>
										{getEntityTypeResArray &&
											[]
												.concat(getEntityTypeResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">
															{row.entityType}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px",
																	margin: "0 8px"
																}}
																onClick={() => updateEntityTypeList(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
															{/* </TableCell>
														<TableCell align="center"> */}
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => updateEntityTypeList(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getEntityTypeResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Entity Type</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Entity Type"
								fullWidth={true}
								variant="standard"
								name="EditEntityType"
								value={editEntityType || ""}
								onChange={handleChange}
							></TextField>

							<FormControlLabel
								style={{ marginLeft: "0px", marginTop: "10px" }}
								checked={isIndividual}
								control={<Checkbox color="primary" />}
								label="Is Individual"
								labelPlacement="start"
								onChange={(e) => handleCheckboxChange(e)}
							/>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateEntityTypeFunc}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Entity Type</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Entity Type"
								fullWidth={true}
								variant="standard"
								name="EditEntityType"
								value={editEntityType || ""}
								disabled={true}
							></TextField>

							<FormControlLabel
								style={{ marginLeft: "0px", marginTop: "10px" }}
								checked={isIndividual}
								control={<Checkbox color="primary" />}
								label="Is Individual"
								labelPlacement="start"
								disabled={true}
							/>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle>Add Entity Type</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Entity Type"
								variant="standard"
								fullWidth={true}
								name="EditEntityType"
								value={editEntityType || ""}
								onChange={handleChange}
							></TextField>

							<FormControlLabel
								style={{ marginLeft: "0px", marginTop: "10px" }}
								// checked={isIndividual}
								control={<Checkbox color="primary" />}
								label="Is Individual"
								labelPlacement="start"
								onChange={(e) => handleCheckboxChange(e)}
							/>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateEntityTypeFunc}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{updateEntityTypeResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateEntityTypeResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateEntityTypeResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateEntityTypeResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminEntityTypeManagement;
